import { useQuery } from '@tanstack/react-query';

import { baseClient } from '../../app/baseClient';

interface TenantSettingResponse {
  value: boolean;
}

async function getTenantSetting(settingName: string) {
  const { data } = await baseClient.get<TenantSettingResponse>(
    `/tenants/settings/${settingName}`
  );
  return data?.value;
}

export const useTenantSetting = (settingName: string) => {
  return useQuery({
    queryKey: ['tenantSetting', settingName],
    queryFn: () => getTenantSetting(settingName),
    refetchOnWindowFocus: false,
    enabled: !!settingName,
  });
};

export const tenantConfigApi = {
  getTenantSetting,
};
